import { fabric } from 'fabric';

/**
 * @function createSvgFromCanvas - create svg from canvas
 * @param {Object} canvasToConvert - fabric canvas object
 * @returns {String} encodeSVG
 */
function createSvgFromCanvas (canvasToConvert) {
    let svg = canvasToConvert.toSVG().toString().replace(/&(?!amp;)/g, '&amp;');
    let encodeSVG = encodeURIComponent(svg);
    return encodeSVG;
}

/**
 * @function generateSvgForOTP - generate svg for otp and return svgAllFormat
 * @param {Object} canvasOptions - canvas options to create canvas elements
 * @returns {Object} svgAllFormat
 */
export function generateSvgForOTP (canvasOptions) {
    let svgAllFormat = {};
    let top = canvasOptions.top;
    let left = canvasOptions.left;
    let customizeText = canvasOptions.customizeText;
    let customizeFont = canvasOptions.customizeFont;
    let customizeColor = canvasOptions.customizeColor;
    let imageToLoad = canvasOptions.imageToLoad;

    let newCanvas = new fabric.StaticCanvas('rebuildCanvas', {
        width: 2000,
        height: 3000,
    });

    const canvasRatio = 7.125; // canvas ratio calculated based on the design dimensions of the image (2000/355)
    let canvasText = new fabric.Textbox(customizeText, {
        top: top,
        left: left,
        originX: 'center',
        originY: 'center',
        width: canvasRatio * 48,
        fontSize: canvasRatio * 10,
        lineHeight: canvasRatio * 15,
        fontFamily: customizeFont,
        textAlign: 'center',
        fill: customizeColor,
    });

    let img = $(imageToLoad)[0];
    let canvasImage = new fabric.Image(img, {
        top: 0,
        selectable: false,
        hasRotatingPoint: true,
        width: 2000,
        height: 3000
    });
    canvasImage.scaleToWidth(2000);

    let canvasGroup = new fabric.Group([canvasImage, canvasText], {});
    newCanvas.add(canvasGroup);

    // FULL TEXT SVG
    svgAllFormat.personalizationFullSVG = createSvgFromCanvas(newCanvas);

    // HALF SIZE SVG
    let scaleRatio = Math.min(0.5);
    newCanvas.setDimensions({ width: newCanvas.getWidth() * scaleRatio, height: newCanvas.getHeight() * scaleRatio });
    newCanvas.setZoom(scaleRatio);
    svgAllFormat.personalizationSmallSVG = createSvgFromCanvas(newCanvas);

    // ONLY TEXT SVG
    canvasGroup.remove(canvasImage);
    newCanvas.clear();
    newCanvas.add(canvasGroup);
    let personalizationTextSVG = createSvgFromCanvas(newCanvas);
    svgAllFormat.personalizationTextSVG = personalizationTextSVG;

    return svgAllFormat;
}
